import { createValueReducer } from "../../../Redux/Reducers/ValueReducer";
import { ProjectOrTask } from "../../index";
import { ActionTypes } from "../const/ActionTypes";

export type MessageEditorInfoState = {
    projectOrTask?: ProjectOrTask;
    projectId?: number;
};

export const messageEditorInfoReducer = createValueReducer<MessageEditorInfoState>(
    ActionTypes.SET_MESSAGE_EDITOR_INFO,
    null
);
